/**
 * Thin client logger. No-ops in production; in development mirrors to console.
 *
 * This is the single console.* surface in the web app (§7.5). Every other
 * module must call these helpers rather than touching console directly.
 */
import type { LogLevel } from './types';

const isProd: boolean = import.meta.env.PROD;

function log(level: LogLevel, args: unknown[]): void {
  if (isProd) return;
  // WHY: dev-only console access; gated by isProd so prod builds emit nothing.
  const fn = level === 'debug' ? console.debug : level === 'warn' ? console.warn : console.error;
  fn('[syncreel]', ...args);
}

export const logger = {
  /** Debug-level trace; dev only. */
  debug: (...args: unknown[]) => log('debug', args),
  /** Warning; dev only. */
  warn: (...args: unknown[]) => log('warn', args),
  /** Error; dev only (production error reporting is out of scope for WS-5). */
  error: (...args: unknown[]) => log('error', args),
};
